import { createUseStyles } from 'react-jss'

export default createUseStyles({
  messagesContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: 'var(--secondary__page__background__color)'
  },
  messageEnd: {
    clear: 'both',
    float: 'left',
    width: '100%'
  },
  responsive: {
    overflowY: 'auto',
    overflowX: 'hidden',
    flexDirection: 'column',
    /*
     * DEV-5128: ResponsiveContainer's wrapper uses
     * `justify-content: center` for horizontal centering with the
     * default `flex-direction: row`. When we override to
     * `flex-direction: column`, the same `justify-content: center`
     * silently becomes VERTICAL centering — pushing half of the
     * overflow above the scroll top. At 8261px of content in a 632px
     * viewport that left the first bubble at y = -7572, unreachable
     * by scrolling. Force `flex-start` so the first message anchors
     * to the top of the scroller. `!important` is required because
     * JSS inserts the wrapper style AFTER responsive (React renders
     * parent before child), so without it the wrapper's
     * `justify-content: center` wins on specificity ties.
     */
    justifyContent: 'flex-start !important',
    margin: '0 auto',
    backgroundColor: 'var(--secondary__page__background__color)',
    flex: 1
  },
  messagesExpiryBanner: {
    /*
     * DEV-5039: dark mode needs a banner bg distinct from the tab bar
     * (which uses --primary__page__background = DARK). The shared
     * --section__background__color also resolves to DARK in dark mode,
     * so override with a lighter shade that contrasts with both the
     * tab bar (DARK) and the chat page bg (DARK_SECONDARY).
     */
    backgroundColor: 'var(--section__background__color)',
    padding: '10px',
    textAlign: 'center',
    '@media screen and (prefers-color-scheme: dark)': {
      backgroundColor: '#4A5159'
    }
  },
  noMessages: {
    margin: 'auto'
  },
  noMessagesText: {
    fontStyle: 'italic'
  },
  text: {
    color: '#070C1299',
    marginTop: '10px',
    fontSize: '16px',
    fontFamily: 'BentonSansRegular',
    lineHeight: '22px',
    '@media screen and (prefers-color-scheme: dark)': {
      color: '#FFFFFF99'
    }
  },
  footerText: {
    fontSize: '14px'
  }
})
